import Vue from 'vue';

const STORAGE_KEY = 'music_room_theme';
export const roomThemes = [
  { id: 'cream', label: '暖白', color: '#e74c3c' },
  { id: 'ocean', label: '深海', color: '#387f98' },
  { id: 'violet', label: '暗夜', color: '#7956bd' }
];

function validTheme(id) {
  return roomThemes.some(item => item.id === id) ? id : 'cream';
}

function readTheme() {
  try {
    return validTheme(window.localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return 'cream';
  }
}

export const themeState = Vue.observable({ current: readTheme() });

export function setRoomTheme(id) {
  themeState.current = validTheme(id);
  document.documentElement.setAttribute('data-room-theme', themeState.current);
  try {
    window.localStorage.setItem(STORAGE_KEY, themeState.current);
  } catch (e) { /* Storage can be unavailable; switching still works. */ }
}

// Apply before mounting so dialogs appended to body share the same palette.
setRoomTheme(themeState.current);
